export enum HrisProvider {
  BambooHr = 'bamboo_hr',
  FactorialHr = 'factorial_hr',
  HiBob = 'hi_bob',
  Humaans = 'humaans',
  Personio = 'personio',
  Zelt = 'zelt',
}
